const DEVICE_LIMIT_KEY = 'device_limit_flag';

export interface DeviceLimitFlag {
  isLimitReached: boolean;
  deviceCount: number;
  timestamp: number;
}

export const setDeviceLimitFlag = (deviceCount: number): void => {
  const flag: DeviceLimitFlag = {
    isLimitReached: true,
    deviceCount,
    timestamp: Date.now(),
  };
  localStorage.setItem(DEVICE_LIMIT_KEY, JSON.stringify(flag));
};

export const getDeviceLimitFlag = (): DeviceLimitFlag | null => {
  try {
    const raw = localStorage.getItem(DEVICE_LIMIT_KEY);
    if (!raw) return null;
    const parsed: DeviceLimitFlag = JSON.parse(raw);
    return parsed;
  } catch {
    localStorage.removeItem(DEVICE_LIMIT_KEY);
    return null;
  }
};

export const clearDeviceLimitFlag = (): void => {
  localStorage.removeItem(DEVICE_LIMIT_KEY);
};

export const isDeviceLimitActive = (): boolean => {
  try {
    const flag = getDeviceLimitFlag();
    return flag !== null && flag.isLimitReached === true;
  } catch {
    return false;
  }
};
